import React, { FC } from 'react';

export const IconMoon: FC = () => {
   return (
      <svg
         id="Capa_1"
         height="512"
         viewBox="0 0 490.914 490.914"
         width="512"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g>
            <path
               d="m476.09 205.694c-18.628-114.523-113.616-197.586-224.49-205.657-11.214-.816-18.117 12.129-10.984 20.821 28.435 34.651 45.348 79.12 44.88 127.551-1.053 109.097-91.22 197.34-200.316 196.149-19.812-.216-38.926-3.343-56.935-8.97-10.783-3.369-20.262 7.811-15.284 17.952 46.428 94.573 150.659 151.941 260.037 134.15 133.953-21.789 224.881-148.043 203.092-281.996z"
               fill="#fee97d"
            />
            <path
               d="m38.731 394.967c20.584 5.069 42.18 7.877 64.455 8.1 142.446 1.425 260.177-104.065 261.553-234.483.61-57.896-61.629-156.937-62.11-159.3-16.457-4.832-33.545-7.974-51.03-9.247-11.214-.816-18.117 12.129-10.984 20.821 28.436 34.651 45.348 79.12 44.88 127.551-1.053 109.097-91.22 197.34-200.316 196.149-19.813-.216-38.926-3.343-56.935-8.97-10.783-3.369-20.262 7.811-15.284 17.952 7.249 14.764 15.906 28.621 25.771 41.427z"
               fill="#fee45a"
            />
            <path
               d="m199.002 206.467c-8.227-5.336-14.99-12-20.192-20.079-2.424-3.765-7.926-3.83-10.523-.182-5.27 7.404-12.027 13.935-20.101 19.693-3.717 2.651-3.561 8.299.309 10.722 8.052 5.043 14.799 11.572 20.057 19.794 2.423 3.789 7.98 3.803 10.47.058 5.09-7.654 11.925-13.973 20.035-19.316 3.875-2.55 3.836-8.166-.055-10.69z"
               fill="#fee97d"
            />
            <path
               d="m76.246 87.339c-8.227-5.336-14.99-12-20.192-20.079-2.424-3.765-7.926-3.83-10.523-.182-5.27 7.404-12.027 13.935-20.101 19.693-3.717 2.651-3.561 8.299.309 10.722 8.052 5.043 14.799 11.572 20.057 19.794 2.423 3.789 7.98 3.803 10.47.058 5.09-7.654 11.925-13.973 20.035-19.316 3.874-2.551 3.836-8.167-.055-10.69z"
               fill="#fee97d"
            />
            <g>
               <path
                  d="m166.396 110.312c-4.143 0-7.5-3.358-7.5-7.5v-28.074c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v28.073c0 4.143-3.357 7.501-7.5 7.501z"
                  fill="#fef48b"
               />
            </g>
            <g>
               <path
                  d="m180.433 96.275h-28.073c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h28.073c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z"
                  fill="#fef48b"
               />
            </g>
            <g>
               <path
                  d="m55.331 249.078c-4.143 0-7.5-3.358-7.5-7.5v-28.073c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v28.073c0 4.142-3.358 7.5-7.5 7.5z"
                  fill="#fef48b"
               />
            </g>
            <g>
               <path
                  d="m69.367 235.041h-28.073c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h28.073c4.143 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z"
                  fill="#fef48b"
               />
            </g>
         </g>
      </svg>
   );
};
